import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { solicitor } from 'src/app/service/common/interface';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';
import { SolicitorService } from 'src/app/service/pages/solicitors.service';

@Component({
  selector: 'app-team-modal',
  templateUrl: './team-modal.component.html',
  styleUrls: ['./team-modal.component.css']
})
export class TeamModalComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  titles : any;
  solicitor : solicitor = {
    id : "", 
    companyId : "",
    titleId : "",
    fname : "", 
    lname : "", 
    email : "", 
    emailTwo : "", 
    telephone : "",
    directTelephone : "",
    mobile : "", 
    note : "",
    active : ""
  }

  constructor(
    private dialogRef : MatDialogRef<TeamModalComponent>,
    private supportService : SupportService,
    private solicitorService : SolicitorService,
    private messageService : MessageService,
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this._subs.add(
      this.supportService.getNames('titles').subscribe(res => {
        this.titles = res.data;
      })
    )

    if(this.data.id){
      this.solicitorService.getSolicitorTeam(this.data.id).subscribe(res=> {
        this.solicitor = res.data;
      })
    }
  }

  saveTeam(team){
    team.solicitorId = this.data.solicitorId;
    if(this.data.id != null){
      this.updateAction(team);
    }else{
      this.saveAction(team);
    }
  }

  saveAction(team){
    this._subs.add(
      this.solicitorService.saveSolicitorTeam(team).subscribe(res => {
        console.log(res);
        if(res.status == 'ok'){
          this.messageService.success(res.message);
          this.dialogRef.close(res);
        }else{
          this.messageService.error(res.message);
        }
      })
    )
  }

  updateAction(team){
    this._subs.add(
      this.solicitorService.updateSolicitorTeam(this.data.id, team).subscribe(res => {
        if(res.status == 'ok'){
          this.messageService.success(res.message);
          this.dialogRef.close(res);
        }else{
          this.messageService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

}
